import React from "react";
import AdditionalFieldRepository from "../../../repository/AdditionalFieldRepository";
import StandardFormComponent from "../../basics/form/StandardFormComponent";
import { withRouter } from 'react-router-dom';
import FormToastComponent from "../../basics/FormToastComponent";
import FormHelper from "../../../helpers/FormHelper";
import CheckPermissions from "../../../helpers/CheckPermissions";
import UserRolesEnum from "../../../enums/UserRolesEnum";
import AdditionalFieldTextFormComponent from "./forms/AdditionalFieldTextFormComponent";
import Module from "../../../models/module/Module";
import AdditionalField from "../../../models/module/additionalfield/AdditionalField";
import AdditionalFieldContent from "../../../models/module/additionalfield/AdditionalFieldContent";
import { LoaderComponent } from "../../basics/layout";
import { ModuleRepository } from "../../../repository";

class AdditionalFieldFormComponent extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            model: this.props.model !== undefined ? this.props.model : new AdditionalFieldContent(),
            loading: true,
            settings: {},
            isEdit: false,
            roles: this.props.user.roles,
        };

        this.table_ref = React.createRef();

        this.customProps = { ...this.props };
        this.isManager = CheckPermissions.role(this.state.roles, UserRolesEnum.MANAGER) && !CheckPermissions.role(this.state.roles, UserRolesEnum.RESELLER);
    }

    componentDidMount() {
        let promises = [ModuleRepository.get(this.props.match.params.module)];

        if (this.props.get_promise !== undefined) {
            promises.push(this.props.get_promise);
        }

        Promise.all(promises)
            .then(result => {
                Module.set(result[0]?.module);

                let model = this.state.model;
                if (result[1] !== undefined) {
                    model = AdditionalField.fromJson(result[1].additionalfield);
                    let content = model.contents.filter(content => content.language === this.props.match.params.language)[0];

                    model.label = content.label;
                    model.help_text = content.help_text;
                    model.extra_info_website = content.extra_info_website === '[]' ? { text: null } : JSON.parse(content.extra_info_website);
                    model.prefix_choices = content.prefix_choices;
                    model.suffix_choices = content.suffix_choices;
                    model.url_link_text = content.url_link_text;
                }

                this.setState({
                    loading: false,
                    settings: {
                        type: model.field_type,
                        has_prefix_choices: model.has_prefix_choices,
                        has_suffix_choices: model.has_suffix_choices,
                        isWizard: CheckPermissions.role(this.state.roles, UserRolesEnum.WIZARD)
                    },
                    model: model,
                    isEdit: model.id
                });
            });
    }

    getBeforeSubmit = (element) => AdditionalFieldTextFormComponent.fields_image_before_submit(element)

    handleChange = (setting, value) => {
        this.setState({
            settings: {
                ...this.state.settings,
                [setting]: value
            }
        });

        return value;
    }

    render() {
        if (this.state.loading) return <LoaderComponent />;

        return (
            <StandardFormComponent
                {...this.customProps}
                ref={this.table_ref}
                parent={this}
                className="additional-field"
                validationSchema={AdditionalField.schema(this.state.settings)}
                model={this.state.model}
                formSubmit={(values, _) => {
                    if (this.state.isEdit) {
                        return AdditionalFieldRepository.update({ id: values.id, language: this.props.match.params.language, ...values })
                            .then(() => {
                                FormToastComponent.successTrans("AdditionalField", "Default.saved");
                                this.props.history.push('/modules/' + this.props.match.params.module + '/additionalfields');
                            })
                            .catch(error => FormHelper.handleSubmitError(this, error))
                    } else {
                        return AdditionalFieldRepository.create(values)
                            .then(() => {
                                FormToastComponent.successTrans("AdditionalField", "Default.saved");
                                this.props.history.push('/modules/' + this.props.match.params.module + '/additionalfields');
                            })
                            .catch(error => FormHelper.handleSubmitError(this, error))
                    }
                }}
                formErrors={this.state.form_errors}
                fields={AdditionalFieldTextFormComponent.fields({ ...this.state.settings, ...{ onChange: this.handleChange, isEdit: this.state.isEdit } })}
            />
        );
    }
}

export default withRouter(AdditionalFieldFormComponent);